import Vue from 'vue'
import {
    formatNumber,
    formatDate,
    formatDateRange,
    formatCurrency,
    formatNullableCurrency,
    capitalize,
    indefinite,
    trimDecimals,
    formatDateTime
} from '../utils'

Vue.filter('number', formatNumber)
Vue.filter('date', formatDate)
Vue.filter('dateTime', formatDateTime)
Vue.filter('dateRange', formatDateRange)
Vue.filter('currency', formatCurrency)
Vue.filter('currencyOrDash', formatNullableCurrency)
Vue.filter('capitalize', capitalize)
Vue.filter('indefinite', indefinite)
Vue.filter('trimDecimals', trimDecimals)
